import "./css.js";

// Helper to safely parse JSON from script element
function parseJsonScript(id) {
    const el = document.getElementById(id);
    return el ? JSON.parse(el.textContent) : null;
}

// Try to get values immediately (works when this script runs after body content)
// If elements don't exist yet, they'll be null
export let instId = parseJsonScript("inst-id");
export let isObserver = parseJsonScript("is-observer");

// Sidebar collapse functionality
function initSidebar() {
    const sidebar = document.getElementById("hs-sidebar-footer");
    const toggleBtn = document.getElementById("sidebar-toggle");

    // Prevent double initialization
    if (!sidebar || !toggleBtn || toggleBtn.dataset.initialized) {
        return;
    }
    toggleBtn.dataset.initialized = "true";

    // Restore collapsed state from localStorage
    const isCollapsed = localStorage.getItem("sidebar-collapsed") === "true";
    if (isCollapsed) {
        sidebar.classList.add("collapsed");
    }
    // Remove the pre-render classes now that JS has taken over
    document.documentElement.classList.remove("sidebar-is-collapsed");
    document.documentElement.classList.remove("sidebar-section-0-collapsed");
    document.documentElement.classList.remove("sidebar-section-1-collapsed");

    // Overflow fade: dissolve the menu into the chrome at whichever edge still has
    // content to scroll (and not at all when it fits). CSS reads .fade-top/.fade-bottom.
    const navMenu = sidebar.querySelector("nav");
    function updateNavFade() {
        if (!navMenu) return;
        const atTop = navMenu.scrollTop <= 0;
        const atBottom = navMenu.scrollTop + navMenu.clientHeight >= navMenu.scrollHeight - 1;
        navMenu.classList.toggle("fade-top", !atTop);
        navMenu.classList.toggle("fade-bottom", !atBottom);
    }
    navMenu?.addEventListener("scroll", updateNavFade, { passive: true });
    globalThis.addEventListener("resize", updateNavFade);

    // Toggle sidebar on button click
    toggleBtn.addEventListener("click", () => {
        sidebar.classList.toggle("collapsed");
        const collapsed = sidebar.classList.contains("collapsed");
        localStorage.setItem("sidebar-collapsed", collapsed);
    });

    // Section toggle (Review, Education)
    sidebar.querySelectorAll(".sidebar-section-toggle").forEach((btn, index) => {
        const section = btn.closest(".sidebar-section");
        const key = `sidebar-section-${index}-collapsed`;

        // Restore section state
        if (localStorage.getItem(key) === "true") {
            section.classList.add("section-collapsed");
        }

        btn.addEventListener("click", () => {
            section.classList.toggle("section-collapsed");
            localStorage.setItem(key, section.classList.contains("section-collapsed"));
            updateNavFade(); // collapsing a section changes the menu height
        });
    });

    updateNavFade(); // initial state, once collapsed/section state is restored

    // Mobile hamburger menu toggle
    const mobileToggleBtn = document.querySelector('[data-hs-overlay="#hs-sidebar-footer"]');
    if (mobileToggleBtn) {
        mobileToggleBtn.addEventListener("click", () => {
            const isOpen = sidebar.classList.contains("mobile-open");
            if (isOpen) {
                closeMobileSidebar(sidebar);
            } else {
                openMobileSidebar(sidebar);
            }
        });

        // Close sidebar when clicking outside
        document.addEventListener("click", (e) => {
            if (
                sidebar.classList.contains("mobile-open") &&
                !sidebar.contains(e.target) &&
                !mobileToggleBtn.contains(e.target)
            ) {
                closeMobileSidebar(sidebar);
            }
        });

        // Close sidebar on escape key
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && sidebar.classList.contains("mobile-open")) {
                closeMobileSidebar(sidebar);
            }
        });
    }
}

function openMobileSidebar(sidebar) {
    sidebar.classList.add("mobile-open");
    sidebar.classList.remove("hidden");
    document.body.style.overflow = "hidden";
}

function closeMobileSidebar(sidebar) {
    sidebar.classList.remove("mobile-open");
    sidebar.classList.add("hidden");
    document.body.style.overflow = "";
}

function initDarkMode() {
    const btn = document.getElementById("dark-mode-toggle");
    if (!btn || btn.dataset.initialized) return;
    btn.dataset.initialized = "true";

    function applyDark(isDark) {
        document.documentElement.classList.toggle("dark", isDark);
        btn.setAttribute("aria-pressed", String(isDark));
        try {
            localStorage.setItem("dark-mode", isDark ? "true" : "false");
        } catch {
            // storage unavailable (private browsing quota exceeded, etc.) — keep in-memory state only
        }
    }

    btn.addEventListener("click", () => {
        applyDark(!document.documentElement.classList.contains("dark"));
    });

    // Sync aria-pressed with the state already applied by the flash-prevention script
    btn.setAttribute("aria-pressed", String(document.documentElement.classList.contains("dark")));
}

// Initialize sidebar and Preline when DOM is ready
function init() {
    initSidebar();
    initDarkMode();
    // Re-initialize Preline components to ensure dropdowns work
    if (globalThis.HSStaticMethods?.autoInit) {
        globalThis.HSStaticMethods.autoInit();
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}
